import { render } from "./ActionDialogWorkCenter.vue?vue&type=template&id=7e962bfa&scoped=true"
import script from "./ActionDialogWorkCenter.vue?vue&type=script&lang=ts"
export * from "./ActionDialogWorkCenter.vue?vue&type=script&lang=ts"

import "./ActionDialogWorkCenter.vue?vue&type=style&index=0&id=7e962bfa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7e962bfa"

export default script